export type AddressType = 'residence' | 'domicile' | 'shipping';
